import { render, staticRenderFns } from "./UserContextMenu.vue?vue&type=template&id=7a8f59d1&"
import script from "./UserContextMenu.vue?vue&type=script&lang=js&"
export * from "./UserContextMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports